// extracted by mini-css-extract-plugin
export default {"indicator":"PinnedObjectLoadingIndicator__indicator__CHvIb"};